/* DemoPool page-transition loader + hover prefetch fallback (12.10.2026). Markup and CSS are inline in layout/theme.liquid (#dpnav).
   - Shows the top bar + mirror ball on a plain left-click of an internal link (menu, tiles, cards, collection links) and on
     same-origin GET form submits. Skipped for: #anchors on the same page, target=_blank, download, modifier/middle clicks,
     links whose click handler called preventDefault (mini-cart, add to cart, dialogs), checkout/cart actions, [data-no-loader].
   - Lives until the page goes away; pageshow (also from bfcache) resets it, and a 15 s safety timer hides it if nothing happened.
   - API for other scripts: dpNav.start(), dpNav.done().
   - Browsers without speculation rules (Firefox; Safari ignores both) get <link rel=prefetch> on hover / touchstart.
     The same exclusions as the speculation rules in layout/theme.liquid. Skipped on Save-Data / 2G. */
(() => {
  const el = document.getElementById('dpnav');
  const NO = /^\/(cart|checkout|checkouts|account|discount|apps|cdn)(\/|$|\?)/;
  let timer = 0;
  const done = () => { clearTimeout(timer); if (el) el.classList.remove('is-on'); };
  const start = () => {
    if (!el) return;
    done(); void el.offsetWidth;                       // restart the animation from 0
    el.classList.add('is-on');
    timer = setTimeout(done, 15000);
  };
  window.dpNav = { start, done };

  const internal = a => {
    if (!a || a.hasAttribute('download') || a.hasAttribute('data-no-loader')) return null;
    if (a.target && a.target !== '_self') return null;
    const raw = a.getAttribute('href');
    if (!raw || raw[0] === '#' || /^(mailto|tel|sms|javascript):/i.test(raw)) return null;
    let u; try { u = new URL(a.href, location.href); } catch (_) { return null; }
    if (u.origin !== location.origin) return null;
    if (u.hash && u.pathname === location.pathname && u.search === location.search) return null;   // same-page anchor
    return u;
  };

  document.addEventListener('click', e => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]');
    const u = internal(a); if (!u || /^\/(checkout|checkouts|cart\/)/.test(u.pathname)) return;
    setTimeout(() => { if (!e.defaultPrevented) start(); }, 0);   // after every other click handler had its say
  });
  document.addEventListener('submit', e => {
    const f = e.target; if (!(f instanceof HTMLFormElement)) return;
    if ((f.method || 'get').toLowerCase() !== 'get' || (f.target && f.target !== '_self')) return;
    let u; try { u = new URL(f.action || location.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin || /^\/cart/.test(u.pathname)) return;
    setTimeout(() => { if (!e.defaultPrevented) start(); }, 0);
  });
  addEventListener('pageshow', done);
  addEventListener('pagehide', done);

  /* hover prefetch fallback */
  let spec = false; try { spec = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'); } catch (_) {}
  const c = navigator.connection;
  if (spec || (c && (c.saveData || /2g/.test(c.effectiveType || '')))) return;
  const seen = new Set([location.pathname + location.search]); let hov = 0;
  const pre = a => {
    const u = internal(a); if (!u || NO.test(u.pathname) || /preview_theme_id/.test(u.search)) return;
    const k = u.pathname + u.search; if (seen.has(k) || seen.size > 24) return; seen.add(k);
    const l = document.createElement('link'); l.rel = 'prefetch'; l.href = k; l.as = 'document'; document.head.appendChild(l);
  };
  document.addEventListener('mouseover', e => {
    const a = e.target.closest && e.target.closest('a[href]'); clearTimeout(hov); if (a) hov = setTimeout(() => pre(a), 80);
  }, { passive: true });
  document.addEventListener('touchstart', e => { pre(e.target.closest && e.target.closest('a[href]')); }, { passive: true });
})();
